import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";
import {
  FaChartLine,
  FaLayerGroup,
  FaGavel,
  FaClipboardCheck,
  FaNewspaper,
  FaUserTie,
  FaLeaf,
  FaIndustry,
  FaSearch,
  FaHandsHelping,
  FaBalanceScale,
  FaWallet,
  FaFileSignature,
  FaVoteYea,
  FaPhoneAlt,
  FaBell,
  FaUserFriends,
  FaUniversity,
  FaEnvelopeOpenText,
  FaUsersCog,
  FaCoins,
  FaBuilding,
  FaHeadset,
  FaProjectDiagram,
  FaBullhorn,
  FaShieldAlt,
  FaBook
} from "react-icons/fa";

const investorMenu = [
  [
    { path: "/annual-report", label: "Annual Report/ Annual Return/ Postal Ballot" },
    { path: "/shareholding-pattern", label: "Shareholding Pattern" },
    { path: "/policies-codes", label: "Policies & Codes" },
    { path: "/regulation7-lodr", label: "Regulation 7 of LODR" },
    { path: "/newspaper-publication", label: "Newspaper Publication" },
    { path: "/investor/Committee-Membership-and-Chairmanship.pdf", label: "Committee Membership and Chairmanship", target: "_blank" },
    { path: "/brsr", label: "BRSR" }
  ],
  [
    { path: "/business", label: "Business" },
    { path: "/research-reports", label: "Research Reports" },
    { path: "/welfare-practice", label: "Welfare Practice" },
    { path: "/regulation40-lodr", label: "Regulation 40 of LODR" },
    { path: "/related-party-transaction", label: "Disclosure of Related Party Transaction" },
    { path: "/dividend", label: "Unpaid Dividend" },
    { path: "/disclosures-u-r-30-of-lodr", label: "Disclosures U.R. 30 of LODR" }
  ],
  [
    { path: "/voting-results", label: "Voting Results" },
    { path: "/concall-transcripts", label: "Concall Transcripts" },
    { path: "/notice-intimations", label: "Notice & Other Intimations" },
    { path: "/investor-complaints", label: "Statement of Investor Complaints" },
    { path: "/closure-of-trading-window", label: "Closure of Trading Window" },
    { path: "/letter-to-shareholders", label: "Letter to Shareholders" },
    { path: "/investor/Profile-of-Board-of-Directors.pdf", label: "Profile of Board of Directors", target: "_blank" }
  ],
  [
    { path: "/financial-results", label: "Financial Results" },
    { path: "/corporate-governance", label: "Corporate Governance" },
    { path: "/investor-shareholder-services", label: "Investor/Shareholder Services" },
    { path: "https://www.bseindia.com/stock-share-price/nandan-denim-limited/ndl/532641/corp-announcements/", label: "Corporate Announcement", target: "_blank" },
    { path: "/compliance-report", label: "Secretarial Compliance Report" },
    { path: "/investor/MOA-AOA.pdf", label: "MOA – AOA", target: "_blank" }
  ]
];

//  Flatten all submenu
const allLinks = investorMenu.flat();

//  Auto icon function
// const getIcon = (label) => {
//   const text = label.toLowerCase();

//   if (text.includes("report")) return <FaChartBar style={{ color: "#9333ea" }} />;
//   if (text.includes("share")) return <FaChartBar style={{ color: "#4f46e5" }} />;
//   if (text.includes("policy")) return <FaBalanceScale style={{ color: "#ca8a04" }} />;
//   if (text.includes("governance")) return <FaBuilding style={{ color: "#16a34a" }} />;
//   if (text.includes("financial")) return <FaMoneyBillWave style={{ color: "#059669" }} />;
//   if (text.includes("complaint")) return <FaUsers style={{ color: "#dc2626" }} />;
//   if (text.includes("voting")) return <FaClipboardList style={{ color: "#ea580c" }} />;
//   if (text.includes("research")) return <FaFileAlt style={{ color: "#db2777" }} />;
//   if (text.includes("board")) return <FaUsers style={{ color: "#0891b2" }} />;
//   if (text.includes("announcement")) return <FaBullhorn style={{ color: "#e11d48" }} />;
//   if (text.includes("dividend")) return <FaMoneyBillWave style={{ color: "#65a30d" }} />;
//   if (text.includes("compliance")) return <FaBalanceScale style={{ color: "#d97706" }} />;

//   return <FaFileAlt style={{ color: "#2563eb" }} />;
// };

const iconMap = {
  "Annual Report/ Annual Return/ Postal Ballot": <FaChartLine style={{ color: "#9333ea" }} />,
  "Shareholding Pattern": <FaLayerGroup style={{ color: "#4f46e5" }} />,
  "Policies & Codes": <FaGavel style={{ color: "#ca8a04" }} />,
  "Regulation 7 of LODR": <FaClipboardCheck style={{ color: "#f59e0b" }} />,
  "Newspaper Publication": <FaNewspaper style={{ color: "#e11d48" }} />,
  "Committee Membership and Chairmanship": <FaUserTie style={{ color: "#0ea5e9" }} />,
  "BRSR": <FaLeaf style={{ color: "#db2777" }} />,

  "Business": <FaIndustry style={{ color: "#16a34a" }} />,
  "Research Reports": <FaSearch style={{ color: "#ec4899" }} />,
  "Welfare Practice": <FaHandsHelping style={{ color: "#22c55e" }} />,
  "Regulation 40 of LODR": <FaClipboardCheck style={{ color: "#f97316" }} />,
  "Disclosure of Related Party Transaction": <FaBalanceScale style={{ color: "#eab308" }} />,
  "Unpaid Dividend": <FaWallet style={{ color: "#65a30d" }} />,
  "Disclosures U.R. 30 of LODR": <FaFileSignature style={{ color: "#fb923c" }} />,

  "Voting Results": <FaVoteYea style={{ color: "#ea580c" }} />,
  "Concall Transcripts": <FaPhoneAlt style={{ color: "#a855f7" }} />,
  "Notice & Other Intimations": <FaBell style={{ color: "#f43f5e" }} />,
  "Statement of Investor Complaints": <FaUserFriends style={{ color: "#dc2626" }} />,
  "Closure of Trading Window": <FaUniversity style={{ color: "#0f766e" }} />,
  "Letter to Shareholders": <FaEnvelopeOpenText style={{ color: "#6366f1" }} />,
  "Profile of Board of Directors": <FaUsersCog style={{ color: "#0891b2" }} />,

  "Financial Results": <FaCoins style={{ color: "#059669" }} />,
  "Corporate Governance": <FaBuilding style={{ color: "#15803d" }} />,
  "Investor/Shareholder Services": <FaHeadset style={{ color: "#0284c7" }} />,
  "Corporate Announcement": <FaBullhorn style={{ color: "#be123c" }} />,
  "Secretarial Compliance Report": <FaShieldAlt style={{ color: "#f59e0b" }} />,
  "MOA – AOA": <FaBook style={{ color: "#2563eb" }} />
};

const getIcon = (label) => {
  return iconMap[label] || <FaFileAlt style={{ color: "#2563eb" }} />;
};

const Investors = () => {
  const [hoverIndex, setHoverIndex] = useState(null);

  return (
    <>
      <Helmet>
        <title>Investor Relations | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      <div>
        <div className="relative w-full">
          <img
            src="/imgs/investors/investor.png"
            alt="Chiripal Group Banner"
            className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center">
            <div className="px-4 sm:px-8 md:px-24 lg:px-32">
              <h1 className="text-yellow-400 text-3xl sm:text-5xl md:text-7xl font-bold font-montserrat">
                Investors
              </h1>
              <p className="text-white text-lg sm:text-2xl italic mt-4 text-justify">
              (Disclosure under Regulation 46 of LODR)
            </p>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto py-14 px-4">
          {/* <h2 className="text-3xl font-extrabold text-black font-montserrat, sans-serif mb-10" >
            Investor Information
          </h2> */}

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {allLinks.map((item, index) => (
              <a
                key={index}
                href={item.path}
                target={item.target || "_self"}
                rel="noreferrer"
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(null)}
                style={{
                  boxShadow:
                    hoverIndex === index
                      ? "0 20px 50px rgba(0,0,0,0.15)"
                      : "0 8px 25px rgba(0,0,0,0.06)",

                  transform:
                    hoverIndex === index
                      ? "translateY(-8px)"
                      : "translateY(0)",

                  transition: "all 0.3s ease",
                  border:
                    hoverIndex === index
                      ? "1px solid #3b82f6"   // blue border on hover
                      : "1px solid #dad3d3",  // light border normal
                }}
                className="bg-white rounded-xl p-6 flex flex-col items-center text-center group"
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 mb-4">
                  <div className="text-3xl">
                    {getIcon(item.label)}
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-gray-800 group-hover:text-blue-600">
                  {item.label}
                </h3>
              </a>
            ))}
          </div>
        </div>


      </div>

      <Footer />
    </>
  );
};

export default Investors;
